import { createFeatureSelector } from '@ngrx/store';

import { State } from '../reducers';

export const selectApp = createFeatureSelector<State>('app')
